// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityTrackPlayer-module__action-btn--OizgY";
var _2 = "pfx-CommunityTrackPlayer-module__actions--oGF7n";
var _3 = "#000";
var _4 = "1260px";
var _5 = "1020px";
var _6 = "668px";
var _7 = "1550px";
var _8 = "pfx-CommunityTrackPlayer-module__compact-player--WuiCX";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "pfx-CommunityTrackPlayer-module__cover-img--bfdMa";
var _f = "#f53535";
var _10 = "rgba(0,0,0,.2)";
var _11 = "rgba(255,255,255,.38)";
var _12 = ".38";
var _13 = "rgba(255,255,255,.2)";
var _14 = "#0025ff";
var _15 = "pfx-CommunityTrackPlayer-module__glitch-anim--aWzA4";
var _16 = "pfx-CommunityTrackPlayer-module__glitch-anim-2--pZKw3";
var _17 = "#f60";
var _18 = "#41ead4";
var _19 = "#2cdd78";
var _1a = "#66ab23";
var _1b = "#f5f5f5";
var _1c = "#c3c3c3";
var _1d = "#ececec";
var _1e = "#252525";
var _1f = "#272727";
var _20 = "#c6c6c5";
var _21 = "#333";
var _22 = "#3c3c3c";
var _23 = "#9c9b9b";
var _24 = "#8c8c8c";
var _25 = "#6f6f6e";
var _26 = "#3c3c3b";
var _27 = "#373737";
var _28 = "#6a6a69";
var _29 = "#6f6f6f";
var _2a = "#9f9e9e";
var _2b = "#282828";
var _2c = "#828181";
var _2d = "#1d1d1d";
var _2e = "#979797";
var _2f = "#9c9b9b";
var _30 = "#a7a7a6";
var _31 = "#c6c6c5";
var _32 = "#d8d8d7";
var _33 = "#dddddc";
var _34 = "72px";
var _35 = "40px";
var _36 = "36px";
var _37 = "25px";
var _38 = "18px";
var _39 = "13px";
var _3a = "pfx-CommunityTrackPlayer-module__img-and-waveform--SHElL";
var _3b = "pfx-CommunityTrackPlayer-module__inline-player--HbeDR";
var _3c = "#0025ff";
var _3d = "rgba(255,255,255,.12)";
var _3e = "#6535f5";
var _3f = "2px";
var _40 = "56px";
var _41 = "56px";
var _42 = "#41ead4";
var _43 = "#f60";
var _44 = "#f83600";
var _45 = "#881f00";
var _46 = "18px";
var _47 = "15px";
var _48 = "red";
var _49 = "13px";
var _4a = "rgba(255,255,255,.07)";
var _4b = "#35465c";
var _4c = "#55acee";
var _4d = "pfx-CommunityTrackPlayer-module__waveform-container--CxqLz";
var _4e = "#fff";
var _4f = "#ffce36";
var _50 = "#ffcd00";
var _51 = "red";
export { _1 as "actionBtn", _2 as "actions", _3 as "black", _4 as "breakLarge", _5 as "breakMedium", _6 as "breakSmall", _7 as "breakVLarge", _8 as "compactPlayer", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "coverImg", _f as "danger", _10 as "darkElement", _11 as "disabled", _12 as "disabledOpacity", _13 as "extraLightElement", _14 as "facebook", _15 as "glitchAnim", _16 as "glitchAnim2", _17 as "google", _18 as "green", _19 as "green2", _1a as "greenColor", _1b as "grey1", _1c as "grey10", _1d as "grey2", _1e as "grey25", _1f as "grey27", _20 as "grey3", _21 as "grey33", _22 as "grey3C", _23 as "grey4", _24 as "grey41", _25 as "grey5", _26 as "grey6", _27 as "grey61", _28 as "grey6A", _29 as "grey6F", _2a as "grey7", _2b as "grey8", _2c as "grey82", _2d as "grey9", _2e as "grey97", _2f as "grey9C", _30 as "greyA7", _31 as "greyC6", _32 as "greyD8", _33 as "greyDd", _34 as "header1", _35 as "header2", _36 as "header3", _37 as "header4", _38 as "header5", _39 as "header6", _3a as "imgAndWaveform", _3b as "inlinePlayer", _3c as "klein", _3d as "lightElement", _3e as "lilac", _3f as "menuBorder", _40 as "menuHeight", _41 as "menuMobileHeight", _42 as "ocean", _43 as "orange", _44 as "orange2", _45 as "orangeDark", _46 as "paragraph", _47 as "paragraphSmall", _48 as "red", _49 as "subHeaderSmall", _4a as "subtleLightElement", _4b as "tumblr", _4c as "twitter", _4d as "waveformContainer", _4e as "white", _4f as "yellow", _50 as "yellowDeep", _51 as "youtube" }
